import { render, staticRenderFns } from "./assignment.view.vue?vue&type=template&id=78a96222&scoped=true&"
import script from "./assignment.view.vue?vue&type=script&lang=ts&"
export * from "./assignment.view.vue?vue&type=script&lang=ts&"
import style0 from "./assignment.view.vue?vue&type=style&index=0&id=78a96222&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a96222",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VIcon,VRow})
